import { FeeLevelType } from '../../types/index';
import { atom } from "recoil";

export const addStateFeeLevelFeeLevel = atom({
  key: "addStateFeeLevel",
  default: false,
});
export const editStateFeeLevel = atom({
  key: "editStateFeeLevel",
  default: false,
});
export const editFeeId = atom<number | null>({
  key: "editFeeId",
  default: 0,
});
export const rowEditIdStateFeeLevel = atom<FeeLevelType | null>({
  key: "rowEditIdStateFeeLevel",
  default: {
    feeLevelId: 0,
    feeLevelName: "",
    createdBy: "",
    createdDate: new Date,
    modifiedBy: "",
    modifiedDate: new Date,
    isActive: true
  }
});
export const disableButtonStateFeeLevel = atom({
  key: "disableButtonStateFeeLevel",
  default: false,
});

export const selectedRowsStateFeeLevel = atom<Pick<FeeLevelType, 'feeLevelId'>[] | []>({
  key: "selectedRowsStateFeeLevel",
  default: [],
});

export const setFilterTextFeeLevel = atom({
  key: "setFilterTextFeeLevel",
  default: "",
});


export const feeLevelSaving = atom({
  key: "feeLevelSaving",
  default: false,
});